import { useCallback, useMemo, useState } from "react";
import { Agent } from "../types";
import { AGENTS_PAGE_SIZE, DEFAULT_AGENTS } from "../constants";

export const useAgents = (initialAgents: Agent[] = DEFAULT_AGENTS) => {
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = useMemo(() => {
    if (!query.trim()) return initialAgents;
    const q = query.toLowerCase();
    return initialAgents.filter(
      (a) =>
        a.name.toLowerCase().includes(q) ||
        a.description.toLowerCase().includes(q) ||
        a.category.toLowerCase().includes(q)
    );
  }, [initialAgents, query]);

  const totalPages = useMemo(
    () => Math.max(1, Math.ceil(filtered.length / AGENTS_PAGE_SIZE)),
    [filtered.length]
  );

  const paginated = useMemo(() => {
    const startIndex = (currentPage - 1) * AGENTS_PAGE_SIZE;
    const endIndex = startIndex + AGENTS_PAGE_SIZE;
    return filtered.slice(startIndex, endIndex);
  }, [filtered, currentPage]);

  const setSearchQuery = useCallback((value: string) => {
    setQuery(value);
    setCurrentPage(1);
  }, []);

  return {
    query,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    filtered,
    paginated,
    totalPages,
  } as const;
};


